import classNames from 'classnames';
import { ComponentType, GetPageComponentViewModel } from '@/types/cml-api';
import { NavigationCarousel } from '@/features/carousel';
import { EasyAccess } from '@/features/tag';
import { deviceTypeClassGenerator } from '@/app/(home-page)/_utils/device-type-handlers';
import Skeleton from './skeleton';
import { elementTrackingId } from '../contants';
interface Props {
  data: GetPageComponentViewModel;
}
function CarouselText({
  data
}: Props) {
  return <div className={classNames('homepage-container !pl-0', deviceTypeClassGenerator(data.deviceTypes || ''))} data-sentry-component="CarouselText" data-sentry-source-file="carousel-text.tsx">
            <div className='relative w-full'>
                <NavigationCarousel options={{
        perView: 'auto',
        mode: 'snap',
        spacing: 4
      }} containerClassName='[&>*:last-child]:pl-3' skeleton={<Skeleton />} data-sentry-element="NavigationCarousel" data-sentry-source-file="carousel-text.tsx">
                    {data?.items?.map(({
          title,
          link,
          id
        }, index) => <EasyAccess key={id || link} href={link || ''} size='medium' marketing={{
          elementIndex: index || '0',
          itemId: id,
          elementName: data?.sortKey,
          elementType: ComponentType.CarouselText,
          elementTrackingId,
          componentId: data?.id
        }} className='keen-slider__slide min-w-fit max-w-fit'>
                            {title}
                        </EasyAccess>)}
                </NavigationCarousel>
            </div>
        </div>;
}
export default CarouselText;